import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import About from './AboutResearch';
import AEGLogo from '../../../assets/images/logos/AEG/AEG logo.jpg';
import Achievements from './Achivements/Achivements';
import Clients from '../Clients/Client';
import HomeSlider from '../../Slider/Researchslider/HomeSlider';
import NewContactForm from '../../Forms/NewContactForm';
import NewFooter from '../../common/NewFooter';
import SEO from '../../common/SEO';

const ResearchHome = () => {
  const [showNav, setShowNav] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isHighlighted] = useState(true);
  const prevScrollY = useRef(0);

  const HomeRef = useRef(null);
  const aboutRef = useRef(null);
  const achievementsRef = useRef(null);
  const contactRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setShowNav(
        currentScrollY <= 100 || currentScrollY <= prevScrollY.current
      );

      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobileMenuOpen]);

  const scrollToSection = ref => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


  return (
    <div className='min-h-screen w-full'>
      <SEO 
        title="Scientific Research & SCI Scopus Paper Writing Services Bhopal"
        description="Assurance Education Group provides Scientific Research support, IEEE paper writing, SCI paper writing bhopal, Scopus paper writing bhopal, Research Paper design and publication."
        keywords={[
          "Scientific Research",
          "SCI paper writing bhopal",
          "Scopus paper writing bhopal",
          "IEEE paper writing",
          "Research Paper design and publication",
          "Research paper writing and publication",
          "Paper Writing Bhopal",
          "best thesis writing services in bhopal"
        ]}
        canonicalPath="/research-home"
      />
      {/* Header - Always visible with white background */}
      <header className={`fixed top-0 w-full z-50 bg-white shadow-md transition-all duration-300 ease-in-out ${showNav ? 'translate-y-0' : '-translate-y-full'}`}>
        <nav className='w-full'>
          <div className='flex items-center justify-between px-5 lg:px-20 xl:px-20 2xl:px-20 py-0 bg-white text-black max-w-full'>
            <Link to='' className='flex-shrink-0'>
              <img
                src={AEGLogo}
                alt='Assurance Education Group (AEG Research) Logo - Bhopal'
                className='h-16 w-32 sm:h-20 sm:w-40 lg:h-16 lg:w-32 xl:h-20 xl:w-40 2xl:h-24 2xl:w-48 rounded-2xl ml-0 sm:ml-4 lg:ml-4 xl:ml-8 2xl:ml-12'
              />
            </Link>

            {/* Hamburger Menu Button */}
            <button
              className='lg:hidden text-2xl text-black bg-transparent border-none cursor-pointer hover:text-orange-400 transition-colors duration-300'
              onClick={toggleMobileMenu}
            >
              &#9776;
            </button>

            {/* Navigation Links */}
            <ul
              className={`list-none lg:flex lg:items-center lg:gap-1 xl:gap-3 2xl:gap-6 transition-all duration-300 ease-in-out ${
                isMobileMenuOpen
                  ? 'flex flex-col absolute top-full left-0 right-0 bg-white shadow-lg border-t p-4 text-black gap-4 text-center w-full'
                  : 'hidden lg:flex'
              }`}
            >
              <li>
                <button
                  onClick={() => scrollToSection(HomeRef)}
                  className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection(aboutRef)}
                  className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection(achievementsRef)}
                  className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'
                >
                  Achievements
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection(contactRef)}
                  className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'
                >
                  Contact Us
                </button>
              </li>
              <li>
                <Link to='/products'>
                  <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                    Products
                  </button>
                </Link>
              </li>
              <li>
                <Link to='/services'>
                  <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                    Services
                  </button>
                </Link>
              </li>
              {/* Back to AEG button with highlight effect */}
              {location.pathname !== '/' && (
                <li>
                  <Link to='/'>
                    <button
                      className={`bg-blue-600 text-white px-2 2xl:px-4 text-xs xl:text-sm 2xl:text-base py-2 rounded-full font-bold shadow-lg transform transition-all duration-300 ${
                        isHighlighted ? 'animate-pulse' : ''
                      }`}
                    >
                      Back to ResearchLens
                    </button>
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </header>

      {/* Main Content Sections with top padding to account for fixed header */}
      <div className=''>
        <div ref={HomeRef} id='home'>
          <HomeSlider />
        </div>

        <div ref={aboutRef} id='about'>
          <About />
        </div>

        <div ref={achievementsRef} id='achievements'>
          <Achievements embedded />
        </div>

        <Clients />

        <div ref={contactRef} id='contact'>
          <NewContactForm />
        </div>

        <NewFooter />
      </div>

      {/* Additional utility classes for special cases */}
      <style>{`
        /* Selected state styles - converted to Tailwind-compatible */
        .selected {
          @apply text-red-500 font-semibold border border-red-500 rounded-lg p-2;
        }

        .selected-box {
          @apply transform scale-105 transition-transform duration-200 text-red-500 font-semibold;
        }

        /* New badge with Tailwind-compatible animations */
        .new-badge {
          @apply text-xs font-bold px-2 py-1 bg-red-600 text-gray-100 rounded-md;
          animation: lipLop 0.5s ease-in-out infinite alternate, glow 1.5s ease-in-out infinite alternate;
          text-shadow: 0 0 5px rgba(255, 0, 255, 0.8), 0 0 10px rgba(255, 0, 255, 0.6);
        }

        @keyframes glow {
          from {
            text-shadow: 0 0 10px #ff00ff, 0 0 20px #ff00ff, 0 0 30px #ff00ff;
          }
          to {
            text-shadow: 0 0 15px #8000ff, 0 0 25px #8000ff, 0 0 40px #8000ff;
          }
        }

        @keyframes lipLop {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }

        /* Dropdown and menu styles */
        .dropdown-container {
          @apply flex w-full;
        }

        .menu-section {
          @apply w-80 p-6 bg-orange-100;
        } 

        .menu-section ul {
          @apply flex flex-col gap-4;
        }

        .menu-section ul li a {
          @apply block p-2 transition-all duration-200 hover:bg-black/5 hover:rounded;
        }

        .cards-section {
          @apply flex-1 p-5 grid grid-cols-2 gap-4;
        }

        .menu-card {
          @apply h-40 w-full flex flex-col items-center justify-center rounded-lg transition-transform duration-200 p-4 hover:-translate-y-1;
        }

        /* Group hover effects */
        .group:hover .dropdown-content {
          @apply flex flex-col w-full;
        }

        .dropdown-content {
          @apply hidden;
        }

        /* Mobile responsive */
        @media (max-width: 640px) {
          .cards-section {
            @apply grid-cols-1;
          }
        }

        /* Ultra small screens adjustments */
        @media (max-width: 480px) {
          .nav-links {
            @apply text-sm;
          }
          
          .nav-links li button {
            @apply text-sm;
          }
        }
      `}</style>
    </div>
  );
};

export default ResearchHome;
